import { useEffect } from 'react';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { Box, Checkbox, TextField } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
// Our Components
// Services
import { Users } from 'lib/api';
// Utils and Helpers
// Assets
import './FilterByCardholders.css';

const FilterByCardholder = ({ cardholders, setCardholders, selectedCardholders, setSelectedCardholders, setPagination }) => {
    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const queryParams = {
                    limit: 100,
                    order: 'DESC'
                };
                const { results } = await Users.getUsers(queryParams);
                setCardholders(results);
            } catch (error) {
                console.error(error);
            }
        };
        fetchUsers();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleCardholderFilterChange = (event, newValue) => {
        setSelectedCardholders(newValue);
        setPagination({
            page: 0,
            rowsPerPage: 10
        });
    };

    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: option => `${option.first_name} ${option.last_name} ${option.email} `
    });

    return (
        <Autocomplete
            id="search-contacts-autocomplete"
            fullWidth
            renderInput={params =>
                selectedCardholders.length === 1 ? (
                    <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        label={`${selectedCardholders.length} user selected	-`}
                    />
                ) : (
                    <TextField
                        {...params}
                        InputLabelProps={{ shrink: true }}
                        label={`${selectedCardholders.length} users selected	-`}
                    />
                )
            }
            size="small"
            options={cardholders}
            getOptionLabel={option => `${option.first_name}`}
            clearOnEscape={true}
            filterOptions={filterOptions}
            renderOption={(props, option, { selected }) => (
                <Box key={option.id} {...props}>
                    <Checkbox
                        icon={<CheckBoxOutlineBlank fontSize="small" />}
                        checkedIcon={<CheckBox fontSize="small" />}
                        style={{ marginRight: 8 }}
                        checked={selected}
                    />
                    <Box className="filter-by-cardholders__cardholder">
                        <Box className="filter-by-cardholders__cardholder-name">
                            {option.first_name} {option.last_name}
                        </Box>
                        <Box className="filter-by-cardholders__cardholder-email">{option.email}</Box>
                    </Box>
                </Box>
            )}
            onChange={handleCardholderFilterChange}
            multiple
            disableCloseOnSelect
            ChipProps={{ size: 'small' }}
            sx={{ minWidth: '380px' }}
        />
    );
};

export default FilterByCardholder;
